import axios from '../../api';
import { getDossierQuery } from '../../graphql/queries/dossier.queries';

export default (token) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

    /**
     * Get dossier
     * @param int idDossier 
     * @returns 
     */
    let getDossier = async function (idDossier) {
        const data = JSON.stringify({
            query: `query {
                ${ getDossierQuery(idDossier) }
            }`,
            variables: {}
        });
        const config = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                // TODO: remove after merge of #3262
                'X-AUTH-ROLES': 'DOSSIER_GET_ONE'
            },
            data: data
        };
        return axios(config);
    }

    return { getDossier }
}
